enum FastBoundSerialStatusEnum {
    ACTIVE = "active",
    DISPOSED = "disposed",
    DELETED = "deleted",
    THEFT_LOSS = "theft_loss",
    DESTROYED = "destroyed",
    DISMISSED = "dismissed",
}

export default FastBoundSerialStatusEnum;
